import Badge from 'components/Badge'
import { Installment } from 'types/api/loan'
import { moneyFormat } from 'utils'
import { INSTALLMENT_STATES } from 'constants/credit'
import { isExpired } from 'utils/date'

interface InstallmentCardProps {
  installmentData: Installment
  className?: string
}

const { PENDING, PAYED, LATE, DELAYED } = INSTALLMENT_STATES

const InstallmentCard = ({
  installmentData,
  className = ''
}: InstallmentCardProps) => {
  const {
    number,
    amount,
    due_date: dueDate,
    is_coming_due: isComingDue,
    remaining_amount: remainingAmount,
    state
  } = installmentData

  const isFinished = state === PAYED || state === LATE

  function renderBadge() {
    if ((state === PENDING && isExpired(dueDate)) || state === DELAYED)
      return (
        <Badge className='font-medium h-[1.125rem]' variant='RED'>
          <span>Vencida</span>
        </Badge>
      )

    if (isComingDue)
      return (
        <Badge className='font-medium h-[1.125rem]' variant='YELLOW'>
          <span>Por vencer</span>
        </Badge>
      )

    if (isFinished)
      return (
        <Badge className='font-medium h-[1.125rem]' variant='GREEN'>
          <span>Pagada</span>
        </Badge>
      )
  }

  return (
    <div
      className={`gap-3 justify-between flex rounded-lg py-3 px-4 items-center w-full h-[4.125rem] bg-white border border-gray-500 text-black ${className}`}
    >
      <div className='flex flex-col items-start leading-tight'>
        <p className='text-xs font-bold'>Cuota {number}</p>
        <p className='text-2xs font-medium text-gray-900'>
          {new Date(dueDate).toLocaleDateString('es-AR')}
        </p>
      </div>
      {renderBadge()}
      <div className='shrink-0 text-2xs leading-none gap-1 font-bold text-right flex flex-col'>
        {isFinished ? moneyFormat(amount) : moneyFormat(remainingAmount)}
      </div>
    </div>
  )
}

export default InstallmentCard
